import { makeObservable, observable } from 'mobx';

import { MedicalCaseQuery } from 'chaika-frontend-types/frontend-cms';

import { MedicalCaseList } from '@store/models/SystemFields/MedicalCase';

export class MedicalCaseStore {
    public static Name = 'medicalCaseStore' as const;

    @observable public medicalCaseList: MedicalCaseList = new MedicalCaseList();
    @observable public searchParams?: MedicalCaseQuery;

    public constructor() {
        makeObservable(this);
    }

    public get hasMedicalCases(): boolean {
        return this.medicalCaseList.values.length > 0;
    }
}

export const medicalCaseStore = new MedicalCaseStore();
